export default "__VITE_ASSET__BQCp$cQk__"